import { DateTimePicker } from "@mui/x-date-pickers";
import BaseCadastro from "components/BaseCadastro";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import Mdfe from "model/transportes/mdfe/Mdfe";
import MdfeCte from "model/transportes/mdfe/MdfeCte";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import MdfeService from "service/transportes/MdfeService";

const mdfeService = new MdfeService();

export default function MdfeCadastro() {

    const [mdfe, setMdfe] = useState<Mdfe>(new Mdfe());

    function validar() {
        return true;
    }

    const titulo = "MDFE";

    return <BaseCadastro model={mdfe}
        service={mdfeService}
        setModel={(value: Mdfe) => setMdfe(value)}
        validar={() => validar()}
        urlService="/mdfe"
        pathCadastro="/mdfe"
        tituloPagina={'MDFE'}>

        {titulo ?
            <div className="row">
                <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
            </div>
            : null}

        <div className="row">
            <Label className="col col-sm-12">Conhecimento MDFE</Label>
            <div className="col-sm-12">
                <InputText
                    readOnly
                    required value={mdfe.chMdfe}
                    style={{ width: '30%' }}
                />
            </div>
            <Label className="col col-sm-12">Data e hora emissão</Label>
            <div className="col-sm-12">
                <DateTimePicker
                    readOnly
                    value={dayjs(mdfe.dhEmi)}
                />
            </div>

        </div>

        <div className="row">
            <div className="col col-sm-12 mt-2">
                <BaseDataTableEdit
                    addButtonDisabled
                    isSelection={false}
                    showEdit={false}
                    showDelete={false}
                    tituloLista="CTEs"
                    getNewModel={() => new MdfeCte()}
                    dataKey="key"
                    lista={mdfe ? mdfe.listMdfeCte : []}
                    setLista={(value: MdfeCte[]) => {
                        setMdfe({ ...mdfe, listMdfeCte: value });
                    }}
                    scrollHeight="500px"
                    scrollable={true}
                >
                    <Column field="municipioDescarga.xmunDescarga" header="Municipio Descarga" style={{ width: '30%' }} />
                    <Column field="chCte" header="Conhecimento CTE" style={{ width: '60%' }} />

                </BaseDataTableEdit>
            </div>
        </div>

    </BaseCadastro>
}